import { createListenerMiddleware } from "@reduxjs/toolkit";
import { actions } from "../../../../shared/store/installation/model/slice.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  type: "filterValues/executeQuery/pending",
  effect: (action, listenerApi) => {
    if (action.meta.arg.endpointName === "getAllFilterValues") {
      listenerApi.dispatch(actions.setFiltersReady(false));
    }
  }
});
const { middleware } = listenerMiddleware;
export {
  middleware
};
